// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__ujnwI","spinner":"Loading_spinner__f+29B","loadingSpinner":"Loading_loadingSpinner__SkqV3"};